// Port of portal/ui code in highchartsTooltip.service.js

/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */

import _ from 'lodash';

export function hightLightPoints(inBounds, timeslice) {
    const chart = timeslice.point?.series?.chart;
    if (!chart) return;
    if (!inBounds) {
        highlightPoints([], chart);
        return;
    }
    const allSeries = getAssociatedSeries(chart);
    const highchartsPoints = findHighchartsPoints(allSeries, 'x', timeslice.x);
    const configPoints = findConfigPoints(allSeries, 'x', timeslice.x);
    const allInjected = allPointsAreInjected(configPoints);
    if (allInjected) {
        setAxisCrosshairVisibility(chart.xAxis, false);
    } else {
        setAxisCrosshairVisibility(chart.xAxis, true);
    }
    highlightPoints(highchartsPoints, chart);
}

function allPointsAreInjected(points) {
    return !_.some(points, (point) => point.$injected !== true);
}

function setAxisCrosshairVisibility(axes, isVisible) {
    _.each(axes, (axis) => {
        if (axis.crosshair && !isVisible) {
            axis.oldCrosshair = axis.crosshair;
            axis.crosshair = false;
            axis.hideCrosshair();
        } else if (axis.oldCrosshair && isVisible) {
            axis.crosshair = axis.oldCrosshair;
        }
    });
}

function highlightPoints(highchartsPoints, chart) {
    const points = _.filter(highchartsPoints, isValidHoverPoint);

    const hoverPoints = getPointsByState('hover', chart);

    const pointsToHighlight = _.difference(points, hoverPoints);
    const pointsToClear = _.difference(hoverPoints, points);

    _.each(pointsToClear, (p) => p.setState());
    _.each(pointsToHighlight, (p) => p.setState('hover'));

    function isValidHoverPoint(point) {
        if (point.$injected) return false;
        const markerEnabled = _.get(point, 'marker.enabled') !== false;
        const markerHoverEnabled = _.get(point, 'marker.states.hover.enabled') !== false;

        return markerEnabled && markerHoverEnabled;
    }
}

function getAssociatedSeries(chart) {
    const chartSeries = _.get(chart, 'series');

    return _.reject(chartSeries, (s) => {
        return _.get(s, 'options.showInTooltip') === false;
    });
}

function findHighchartsPoints(allSeries, keyProperty, keyValue) {
    return _(allSeries)
        .map('data')
        .flatten()
        .filter({ [keyProperty]: keyValue })
        .value();
}

function findConfigPoints(allSeries, keyProperty, keyValue) {
    return _(allSeries)
        .map('options.data')
        .flatten()
        .filter({ [keyProperty]: keyValue })
        .value();
}

function getPointsByState(state, chart) {
    return _(chart.series).map('data').flatten().filter({ state }).value();
}
